import { gql } from '../__generated'

export const GET_AUTH_ORGANISATION_ID_FOR_DOMAIN = gql(/* GraphQL */ `
  query GetOrganisationForDomain($domain: String!) {
    getOrganisationForDomain(domain: $domain) {
      authOrganisationId
    }
  }
`)
